module.exports = __webpack_public_path__ + "static/img/4.f417f2c6.jpg";